<template>
  <qx-card title="列表">
    <!--    表格-->
    <section class="tableBox" ref="tableBox">
      <el-table v-loading="tableData.loading" ref="multipleTable" :data="tableData.data" tooltip-effect="dark"
                :height="tableHeight" @select="handleSelectionChange" @select-all="handleSelectionChange">
        <!--        常规列表项-->
        <template v-for="(item, index, key) in tableData.title">
          <el-table-column :key="key" :prop="item.prop" :label="item.label" :sortable="item.sortable"
                           :filters="item.filters" :filter-method="item.filterHandler" :min-width="item.minW"
                           :width="item.w" :fixed="item.fixed" align="center">
          </el-table-column>
        </template>
        <!--        常规列表项end-->
      </el-table>
    </section>
    <!--    表格end-->
    <!--    分页-->
    <section class="paginationBox clearPa">
      <!--      分页组件-->
      <section class="right">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="tableData.page" :page-sizes="[10,20,50]" :page-size="tableData.count"
                       layout="total, sizes, prev, pager, next, jumper" :total="tableData.total"></el-pagination>
      </section>
      <!--      分页组件end-->
    </section>
    <!--    分页end-->
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {getAlarmList} from 'api/service';

export default {
  mixins: [
    tableMixin,
  ],
  components: {},
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        title: [ // 表头
          {prop: 'carNo', label: '车牌号'},
          {prop: 'alarmTypeStr', label: '报警类型'},
          {prop: 'maxSpeedDouble', label: '最高车速'},
          {prop: 'startTime', label: '开始时间'},
          {prop: 'endTime', label: '结束时间'},
          {prop: 'continueTimeStr', label: '持续时间'},
          {prop: 'address', label: '事件发生(结束)地点'},
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: getAlarmList,
  },
};
</script>
